import React from 'react'
import { LocationInitialViewModel } from './LocationInitialViewModel';
import { NavBarComponente } from '../../Components/NavBarComponente';
import { Container, Row, Image, Col, Form, Button } from 'react-bootstrap';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { Marker } from 'leaflet';
import Select from 'react-select';

import "../../Estilo/Form.css";
import fechar from '../../Imagens/close-24.png';
import salvar from '../../Imagens/save-16.png';
import { MapaComponente } from '../../Components/MapaComponente';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";

export interface LocationInitialViewControllerDelegate {
    tapDimiss(navigation: any): void
}

interface MyProps {
    navigation: any
    delegate: LocationInitialViewControllerDelegate
    viewModel: LocationInitialViewModel
}

export class LocationInitialViewController extends React.Component<MyProps> {

    private formEvent: FormEvent
    private marker: any
    private map: any
    private mapClickInitialized = false
    private mapInitialized = false

    state = {
        isLoading: false,
        srid: Array<any>(),
        json: {
            latitude: -30.1087957,
            longitude: -51.3172251
        }
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.loadStruct()
        this.loadSRID()
    }

    render() {
        const json = this.state.json as any

        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />

                <Container fluid>
                    <Row>
                        <Col>
                            <div className="title">
                                <h3>Localização Inicial</h3>
                            </div>

                            <div className="buttonClose">
                                <Image
                                    className="imageClose"
                                    onClick={() => this.props.delegate.tapDimiss(this.props.navigation)}
                                    src={fechar}
                                />
                            </div>
                        </Col>
                    </Row>

                    <Form className="containerForm">
                        <Row>
                            <Col xs="12" className="bottom10">
                                <Form.Label className="isRequired">
                                    Sistema de referência de coordenadas
                                </Form.Label>

                                <Select
                                    id="srid"
                                    value={this.formEvent.onValueSelect('select', 'srid', this.state.srid)}
                                    onChange={(e: any) => this.formEvent.onChange("select", e, "srid")}
                                    placeholder="Selecione"
                                    options={this.state.srid}
                                    isMulti={false}

                                    menuPortalTarget={document.body}

                                    styles={{
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 999999
                                        })
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="4" xs="12" className="bottom10">
                                <Form.Label>Latitude</Form.Label>
                                <Form.Control disabled value={json.latitude || ''} />
                            </Col>

                            <Col lg="4" xs="12" className="bottom10">
                                <Form.Label>Longitude</Form.Label>
                                <Form.Control disabled value={json.longitude || ''} />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12" style={{ marginBottom: 10 }}>
                                <MapaComponente
                                    height={600}
                                    isDraw={false}
                                    isCamada={false}
                                    isSearch={false}
                                    isFilter={false}
                                    isNeighborRelatory={false}
                                    setActivedNeighborRelatory={() => { }}
                                    getClickShape={() => { }}
                                    getMap={(map: any) => this.setMap(map)}
                                    startEdit={() => { }}
                                    saveEdit={() => { }}
                                    cancelEdit={() => { }}
                                    stopDraw={() => { }}
                                    exportPDF={() => { }}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs="12" style={{ marginTop: 20 }}>
                                <Button className="buttonSave" type="button" onClick={() => this.save()}>
                                    <Image className="imageSave" src={salvar} />
                                    Salvar
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                    <ToastContainer />
                </Container>

                <LoaderComponente
                    show={this.state.isLoading}
                    hide={() => this.setState({ isLoading: false })}
                />
            </div>
        )
    }

    private setMap(map: any) {
        if (!map) return;

        this.map = map;

        const json = this.state.json as any;

        // Centraliza apenas na primeira vez
        if (!this.mapInitialized) {
            this.mapInitialized = true;
            map.setView([json.latitude, json.longitude], 15);
        }

        if (!this.marker) {
            this.marker = new Marker(
                [json.latitude, json.longitude],
                { draggable: true }
            );

            this.marker.on('dragend', (e: any) => {
                const { lat, lng } = e.target.getLatLng();

                this.setState({
                    json: {
                        ...this.state.json,
                        latitude: lat,
                        longitude: lng
                    }
                });
            });

            this.marker.addTo(map);
        }

        if (!this.mapClickInitialized) {
            this.mapClickInitialized = true;

            map.on('click', (e: any) => {
                const { lat, lng } = e.latlng;

                if (this.marker) {
                    this.marker.setLatLng([lat, lng]);
                }

                this.setState({
                    json: {
                        ...this.state.json,
                        latitude: lat,
                        longitude: lng
                    }
                });
            });
        }
    }

    private save() {
        const json = this.state.json as any

        if (!json['srid']) {
            toast.error("Campos obrigatórios não preenchidos!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
            return;
        }

        this.props.viewModel.fetchSave(json).then(() => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    private loadStruct() {
        this.setState({ isLoading: true });

        this.props.viewModel.fetchDataOne().then((rs) => {
            const resultado = rs as Array<any>;

            if (resultado.length > 0) {
                const data = resultado[0];

                this.setState({
                    isLoading: false,
                    json: data
                }, () => {

                    if (this.marker) {
                        this.marker.setLatLng([data.latitude, data.longitude]);
                    }

                    if (this.map) {
                        this.map.setView([data.latitude, data.longitude], 15);
                    }
                });

                return;
            }

            this.setState({ isLoading: false });

        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }

    private loadSRID() {
        this.setState({
            srid: [
                { value: 31978, label: "SIRGAS2000 / UTM18S" },
                { value: 31979, label: "SIRGAS2000 / UTM19S" },
                { value: 31980, label: "SIRGAS2000 / UTM20S" },
                { value: 31981, label: "SIRGAS2000 / UTM21S" },
                { value: 31982, label: "SIRGAS2000 / UTM22S" },
                { value: 31983, label: "SIRGAS2000 / UTM23S" },
                { value: 31984, label: "SIRGAS2000 / UTM24S" },
                { value: 31985, label: "SIRGAS2000 / UTM25S" },
                { value: 32718, label: "WGS84 / UTM18S" },
                { value: 32719, label: "WGS84 / UTM19S" },
                { value: 32720, label: "WGS84 / UTM20S" },
                { value: 32721, label: "WGS84 / UTM21S" },
                { value: 32722, label: "WGS84 / UTM22S" },
                { value: 32723, label: "WGS84 / UTM23S" },
                { value: 32724, label: "WGS84 / UTM24S" },
                { value: 32725, label: "WGS84 / UTM25S" },
                { value: 4674, label: "SIRGAS2000" },
                { value: 4326, label: "WGS84" }
            ]
        });
    }
}